import {
  IJobResultingOptionData,
  JobResultingOptionRecord,
  jobResultingOptionFromJSON,
  jobResultingOptionToJSON,
} from "common/records/JobResultingOption";
import { List, Record } from "immutable";

export const jobResultingConfigFromJSON = (json: Partial<IJobResultingConfigData>): JobResultingConfigRecord => {
  const recordData: IJobResultingConfigRecord = { ...(json as any) };

  recordData.options = List(json.options?.map((o) => jobResultingOptionFromJSON(o)));

  if (recordData.options.size === 0) {
    recordData.options = List([
      jobResultingOptionFromJSON({ name: "Sale", default_type: "email" }),
      jobResultingOptionFromJSON({ name: "No Sale", default_type: "email" }),
    ]);
  }

  return new JobResultingConfigRecord(recordData);
};

export const jobResultingConfigToJSON = (config: JobResultingConfigRecord) => {
  const json = config.toJS() as Partial<IJobResultingConfigData>;

  json.options = config.options.map(jobResultingOptionToJSON).toArray();

  return json;
};

export interface IJobResultingConfigData {
  enabled: boolean;
  options: Partial<IJobResultingOptionData>[];
}

export interface IJobResultingConfigRecord {
  enabled: boolean;
  options: List<JobResultingOptionRecord>;
}

export const defaultJobResultingConfigProps: IJobResultingConfigRecord = {
  enabled: false,
  options: List(),
};

export class JobResultingConfigRecord
  extends Record(defaultJobResultingConfigProps)
  implements IJobResultingConfigRecord {}
